<template>
  <ul>
    <li class="heading">
      <h3 class="pt-3">{{ links[1].name }}</h3>
    </li>
    <template v-for="item in links[1].children">
      <!-- <reveal
        v-if="item.children.length && item.href === '#'"
        v-bind:title="item.name"
        v-bind:items="item.children"
      >
      </reveal> -->

      <!-- else -->
      <li>
        <a v-bind:href="item.href">{{ item.name }}</a>
      </li>
    </template>
  </ul>
</template>

<script>
import reveal from "./group-reveal";

export default {
  name: "group",
  props: ["active", "site"],
  components: {
    reveal,
  },
  data() {
    return {
      map: {
        "sleep-apnea": "Sleep Apnea",
        "portable-oxygen": "Portable Oxygen",
        ventilation: "Ventilation",
        "healthcare-professional": "I’m a Healthcare Professional",
        "resmed-corporate": "ResMed Corporate",
      },
      //   items: [],
      links: [],
    };
  },
  watch: {
    site() {
      this.get();
    },
  },
  methods: {
    get() {
      let address;

      // exception
      if (this.site === "healthcare-professional") {
        address = `//${process.env.VUE_APP_API_ENDPOINT}/wp-json/resmed/v1/navigation/healthcare-professionals-header`;
      }
      // exception
      else if (this.site === "resmed-corporate") {
        address = `//${process.env.VUE_APP_API_ENDPOINT}/wp-json/resmed/v1/navigation/resmed-corporate`;
      }
      // default
      else {
        let site = this.site === "consumers" ? "" : this.site;
        address = `//${process.env.VUE_APP_API_ENDPOINT}/${site}/wp-json/resmed/v1/navigation/header-navigation`;
      }

      axios.get(address).then((response) => {
        this.items = response.data;
      });
    },
  },
  created() {
    this.get();
    // Get top menu bar links
    const siteAddress = `${process.env.VUE_APP_API_ENDPOINT}/${this.$route.params.region}/wp-json/resmed/v1/navigation/top-navigation`;

    axios.get(siteAddress).then((response) => {
      this.links = response.data;
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";
@import "../../css/components/navigation";

ul {
  li {
    @extend %default-list-style;

    &.group-header {
      background-position: left center;
      background-image: url(#{$assets}/images/icon-left-arrow-black.svg);

      a {
        padding-left: 2rem;
      }
    }

    &.overview {
      background-image: none;

      a {
        @extend %heading-sm;
      }
    }
  }
  .heading {
    background-image: none;
    border-bottom: 0;
    color: #0D0A15;
  }
}
</style>
